export class HomeScreenGroupItem {
    itemId: string;
    picture: string;
    isMovie: boolean;
}


// WEBPACK FOOTER //
// ./src/data/HomeScreenGroupItem.ts